export const CreateIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M6.94129 15.7273L4.12197 16.8526C3.51161 17.0962 3.20643 17.218 3.02801 17.1081C2.97266 17.074 2.92605 17.0273 2.89194 16.972C2.78196 16.7936 2.90377 16.4884 3.14738 15.878L4.27267 13.0587M6.94129 15.7273L16.1704 6.49823M6.94129 15.7273L6.66973 13.9574C6.63409 13.7251 6.61627 13.609 6.55023 13.5237C6.52867 13.4958 6.50366 13.4708 6.4758 13.4493C6.3905 13.3832 6.27434 13.3654 6.04201 13.3298L4.27267 13.0587M4.27267 13.0587L13.5018 3.82961M16.1704 6.49823L13.5018 3.82961M16.1704 6.49823L16.999 5.66961C17.7359 4.93269 17.7359 3.73791 16.999 3.00099V3.00099C16.2621 2.26406 15.0673 2.26406 14.3304 3.00098L13.5018 3.82961M2.5 5.41667C4.16667 5.00001 5 4.16667 5.41667 2.50001C5.83333 4.16667 6.66667 5.00001 8.33333 5.41667C6.66667 5.83334 5.83333 6.66667 5.41667 8.33334C5 6.66667 4.16667 5.83334 2.5 5.41667ZM12.5 13.9583C13.3333 13.75 13.75 13.3333 13.9583 12.5C14.1667 13.3333 14.5833 13.75 15.4167 13.9583C14.5833 14.1667 14.1667 14.5833 13.9583 15.4167C13.75 14.5833 13.3333 14.1667 12.5 13.9583Z"
        stroke="#667085"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

CreateIcon.displayName = "CreateIcon";
